import React, { useEffect, useState, useRef, createElement } from 'react';
const purchases = [{
  name: 'Laura M.',
  city: 'Buenos Aires',
  initials: 'LM',
  product: 'Megapack Nutrición Resuelta',
  time: 'hace 2 min'
}, {
  name: 'Mariela C.',
  city: 'Rosario',
  initials: 'MC',
  product: 'Autoridad Nutricional',
  time: 'hace 5 min'
}, {
  name: 'Sofía V.',
  city: 'Córdoba',
  initials: 'SV',
  product: 'Sistema Nutrición Completa',
  time: 'hace 8 min'
}, {
  name: 'Florencia L.',
  city: 'Tucumán',
  initials: 'FL',
  product: 'Megapack Nutrición Resuelta',
  time: 'hace 12 min'
}, {
  name: 'Ana R.',
  city: 'Mendoza',
  initials: 'AR',
  product: 'Autoridad Nutricional',
  time: 'hace 15 min'
}, {
  name: 'Valeria T.',
  city: 'Santa Fe',
  initials: 'VT',
  product: 'Sistema Nutrición Completa',
  time: 'hace 18 min'
}, {
  name: 'Gabriela R.',
  city: 'Salta',
  initials: 'GR',
  product: 'Megapack Nutrición Resuelta',
  time: 'hace 22 min'
}, {
  name: 'Carolina P.',
  city: 'La Plata',
  initials: 'CP',
  product: 'Autoridad Nutricional',
  time: 'hace 25 min'
}, {
  name: 'Daniela S.',
  city: 'Mar del Plata',
  initials: 'DS',
  product: 'Sistema Nutrición Completa',
  time: 'hace 30 min'
}, {
  name: 'Julieta F.',
  city: 'Neuquén',
  initials: 'JF',
  product: 'Autoridad Nutricional',
  time: 'hace 35 min'
}, {
  name: 'Romina G.',
  city: 'San Juan',
  initials: 'RG',
  product: 'Megapack Nutrición Resuelta',
  time: 'hace 40 min'
}, {
  name: 'Luciana B.',
  city: 'Paraná',
  initials: 'LB',
  product: 'Sistema Nutrición Completa',
  time: 'hace 45 min'
}];
const avatarColors: Record<string, string> = {
  LM: '#0e7490',
  MC: '#7c3aed',
  SV: '#b45309',
  FL: '#065f46',
  AR: '#9f1239',
  VT: '#1d4ed8',
  GR: '#92400e',
  CP: '#0e7490',
  DS: '#7c3aed',
  JF: '#065f46',
  RG: '#b45309',
  LB: '#1d4ed8'
};
export function PurchaseNotifications() {
  const [current, setCurrent] = useState<number | null>(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const init = () => {
      const styleId = 'purchase-notif-keyframes';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          @keyframes notifIn {
            from { opacity: 0; transform: translateY(40px) scale(0.95); }
            to { opacity: 1; transform: translateY(0) scale(1); }
          }
          @keyframes notifOut {
            from { opacity: 1; transform: translateY(0) scale(1); }
            to { opacity: 0; transform: translateY(20px) scale(0.95); }
          }
        `;
        document.head.appendChild(style);
      }
      function showNext() {
        setCurrent(indexRef.current);
        setVisible(true);
        timeoutRef.current = setTimeout(() => {
          setVisible(false);
          indexRef.current = (indexRef.current + 1) % purchases.length;
          const nextDelay = 12000 + Math.random() * 6000;
          timeoutRef.current = setTimeout(showNext, nextDelay);
        }, 4000);
      }
      timeoutRef.current = setTimeout(showNext, 10000);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(init, {
        timeout: 12000
      });
    } else {
      setTimeout(init, 10000);
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  const purchase = current !== null ? purchases[current] : null;
  if (!purchase) return null;
  const bgColor = avatarColors[purchase.initials] || '#15803d';
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" style={{
    animation: visible ? 'notifIn 0.3s ease-out forwards' : 'notifOut 0.3s ease-in forwards',
    pointerEvents: 'none'
  }} data-id="element-288">
      <div className="flex items-center gap-3 bg-white rounded-xl shadow-lg border border-gray-200 px-4 py-3" data-id="element-289">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-black text-white" style={{
        backgroundColor: bgColor
      }} data-id="element-290">
          {purchase.initials}
        </div>
        <div className="min-w-0" data-id="element-291">
          <p className="text-xs font-bold text-gray-900 m-0 truncate" data-id="element-292">
            {purchase.name} — {purchase.city}
          </p>
          <p className="text-[10px] text-gray-500 m-0 truncate" data-id="element-293">
            Compró {purchase.product}
          </p>
          <p className="text-[10px] text-green-600 font-semibold m-0" data-id="element-294">
            ✓ {purchase.time}
          </p>
        </div>
      </div>
    </div>;
}